import styled from 'styled-components';

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: Space-between;
  align-items: center;
  padding: 8px 28px;
  gap: 10px;
`;
